export class PriceMapper {
    static deserialize(price: number): number | null {
        if (price < 0) {
            return null;
        }

        return price;
    }
}